import { render, staticRenderFns } from "./PenwiseWeeklyData.vue?vue&type=template&id=12dddde4&scoped=true"
import script from "./PenwiseWeeklyData.vue?vue&type=script&lang=js"
export * from "./PenwiseWeeklyData.vue?vue&type=script&lang=js"
import style0 from "./PenwiseWeeklyData.vue?vue&type=style&index=0&id=12dddde4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dddde4",
  null
  
)

export default component.exports